import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { resolveActiveOrg, activeOrgSourceLabel } from '../active-org.js';
import { getFormat } from '../helpers.js';

export interface MeResponse {
  auth_kind: string;
  grants_summary: string;
  org_id?: string;
  user_id?: string;
  email?: string;
  orgs?: Array<{ org_id: string; name: string; role: string; slug?: string }>;
}

export const whoamiCommand = new Command('whoami')
  .description('Show the authenticated identity')
  .action(async function (this: Command) {
    const client = new ApiClient();
    const me = await client.request<MeResponse>('GET', '/v1/auth/me');

    if (getFormat(this) === 'json') {
      console.log(JSON.stringify(me, null, 2));
      return;
    }

    console.log(`auth_kind:      ${me.auth_kind}`);
    if (me.email) console.log(`email:          ${me.email}`);
    if (me.user_id) console.log(`user_id:        ${me.user_id}`);
    if (me.org_id) console.log(`org_id:         ${me.org_id}`);
    const active = resolveActiveOrg();
    if (active.orgId && active.source) console.log(`active_org:     ${active.orgId} (from ${activeOrgSourceLabel(active.source)})`);
    console.log(`grants:         ${me.grants_summary}`);
    if (me.orgs && me.orgs.length > 0) {
      console.log('organizations:');
      for (const o of me.orgs) {
        const handle = o.slug ? ` [/o/${o.slug}]` : '';
        console.log(`  ${o.name} (${o.org_id})${handle} — ${o.role}`);
      }
    }
  });
